import React from 'react';
import {useIntl} from 'react-intl';

import {ISupplierCodeProps} from './ISupplierCode';
import messages from './messages';

const SupplierCode = ({supplierCode}: ISupplierCodeProps) => {
	const intl = useIntl();

	return (
		<div className="supplier-code">
			<div className="supplier-code__value">
				{intl.formatMessage(messages.code, {code: supplierCode})}
			</div>
		</div>
	);
};

export default SupplierCode;
